export const TranslateKpiCard = ({
  title,
  value,
  description,
  color = "#111827",
}: {
  title: string;
  value: string;
  description: string;
  color?: string;
}) => {
  return (
    <div
      style={{
        padding: "20px",
        background: "#f9fafb",
        border: "1px solid #eef0f4",
        borderRadius: "16px",
      }}>
      <div
        style={{
          color: "#6b7280",
          fontSize: "13px",
        }}>
        {title}
      </div>

      <div
        style={{
          marginTop: "8px",
          fontSize: "28px",
          lineHeight: 1.2,
          fontWeight: 800,
          color,
        }}>
        {value}
      </div>

      <div
        style={{
          marginTop: "7px",
          color: "#9ca3af",
          fontSize: "12px",
        }}>
        {description}
      </div>
    </div>
  );
};
